import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Skeleton,
  Typography,
  TypographyOwnProps,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import { ReactNode } from 'react'

interface EarningsStatsCardProps {
  avatarStyle?: object
  cardStyle?: object
  icon: ReactNode
  loading?: boolean
  title: string
  titleStyle?: object
  titleVariant?: TypographyOwnProps['variant']
  value: number | string
  valueStyle?: object
}

export const EarningsStatsCard = ({
  avatarStyle,
  cardStyle,
  icon,
  loading,
  title,
  titleStyle,
  titleVariant = 'h4',
  value,
  valueStyle,
}: EarningsStatsCardProps) => (
  <Card sx={cardStyle} variant="outlined">
    <CardContent>
      <Grid container direction="column" spacing={2}>
        <Grid
          item
          sx={{
            alignItems: 'center',
            direction: 'column',
            display: 'flex',
            gap: 2,
          }}
        >
          {loading ? (
            <Skeleton
              animation="wave"
              height={40}
              variant="circular"
              width={40}
            />
          ) : (
            <Avatar
              sx={{
                backgroundColor: grey[100],
                ...avatarStyle,
              }}
            >
              {icon}
            </Avatar>
          )}

          {loading ? (
            <Skeleton
              animation="wave"
              height={28}
              variant="rectangular"
              width="60%"
            />
          ) : (
            <Typography
              sx={{
                color: grey[600],
                ...titleStyle,
              }}
              variant="subtitle1"
            >
              {title}
            </Typography>
          )}
        </Grid>
        <Grid item>
          {loading ? (
            <Skeleton
              animation="wave"
              height={40}
              variant="rectangular"
              width="75%"
            />
          ) : (
            <Typography
              sx={{
                color: grey[700],
                ...valueStyle,
              }}
              variant={titleVariant}
            >
              {value}
            </Typography>
          )}
        </Grid>
      </Grid>
    </CardContent>
  </Card>
)
